import React, { useState } from 'react';

const VEHICLE_TYPES = [
  { value: 'bike', label: 'Bicycle', icon: '🚲', desc: 'Eco-friendly city deliveries' },
  { value: 'boda', label: 'Boda Boda', icon: '🏍️', desc: 'Fast urban rides & deliveries' },
  { value: 'tuktuk', label: 'Tuk Tuk', icon: '🛺', desc: 'Short-distance passenger trips' },
  { value: 'car', label: 'Car', icon: '🚗', desc: 'Premium rides & large deliveries' },
];

const currentYear = new Date()?.getFullYear();
const YEARS = Array.from({ length: 20 }, (_, i) => String(currentYear - i));

const VehicleInfoForm = ({ data, onChange, onNext, onBack }) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!data?.vehicleType) newErrors.vehicleType = 'Please select a vehicle type';
    if (!data?.plateNumber?.trim()) newErrors.plateNumber = 'Plate number is required';
    if (!data?.vehicleModel?.trim()) newErrors.vehicleModel = 'Vehicle model is required';
    if (!data?.vehicleYear) newErrors.vehicleYear = 'Vehicle year is required';
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validate()) onNext();
  };

  const inputClass = (field) =>
    `w-full px-4 py-3 rounded-xl border-2 text-sm font-medium transition-all duration-200 outline-none bg-white text-gray-900 placeholder-gray-400 ${
      errors?.[field]
        ? 'border-red-400 focus:border-red-500' :'border-gray-200 focus:border-yellow-400'
    }`;

  return (
    <div className="max-w-lg mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-2" style={{ color: '#0a1628' }}>
          Vehicle Information
        </h2>
        <p className="text-gray-500 text-sm">
          Tell us about the vehicle you'll use for OnTheGo deliveries and rides.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Vehicle Type */}
        <div>
          <label className="block text-sm font-semibold mb-3" style={{ color: '#0a1628' }}>
            Vehicle Type <span className="text-red-500">*</span>
          </label>
          <div className="grid grid-cols-2 gap-3">
            {VEHICLE_TYPES?.map((v) => (
              <button
                key={v?.value}
                type="button"
                onClick={() => onChange('vehicleType', v?.value)}
                className="p-4 rounded-xl border-2 text-left transition-all duration-200 hover:shadow-md"
                style={{
                  borderColor: data?.vehicleType === v?.value ? '#ffd700' : '#e5e7eb',
                  background: data?.vehicleType === v?.value ? 'rgba(255,215,0,0.08)' : 'white',
                }}
              >
                <div className="text-2xl mb-1">{v?.icon}</div>
                <div className="font-bold text-sm" style={{ color: '#0a1628' }}>
                  {v?.label}
                </div>
                <div className="text-xs text-gray-400 mt-0.5">{v?.desc}</div>
              </button>
            ))}
          </div>
          {errors?.vehicleType && (
            <p className="text-red-500 text-xs mt-1">{errors?.vehicleType}</p>
          )}
        </div>

        {/* Plate Number */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Plate Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="e.g. KCA 123A"
            value={data?.plateNumber || ''}
            onChange={(e) => onChange('plateNumber', e?.target?.value?.toUpperCase())}
            className={inputClass('plateNumber')}
          />
          {errors?.plateNumber && (
            <p className="text-red-500 text-xs mt-1">{errors?.plateNumber}</p>
          )}
        </div>

        {/* Vehicle Model */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Vehicle Model <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="e.g. Honda CB125, Toyota Vitz"
            value={data?.vehicleModel || ''}
            onChange={(e) => onChange('vehicleModel', e?.target?.value)}
            className={inputClass('vehicleModel')}
          />
          {errors?.vehicleModel && (
            <p className="text-red-500 text-xs mt-1">{errors?.vehicleModel}</p>
          )}
        </div>

        {/* Vehicle Year */}
        <div>
          <label className="block text-sm font-semibold mb-1.5" style={{ color: '#0a1628' }}>
            Year of Manufacture <span className="text-red-500">*</span>
          </label>
          <select
            value={data?.vehicleYear || ''}
            onChange={(e) => onChange('vehicleYear', e?.target?.value)}
            className={inputClass('vehicleYear')}
          >
            <option value="">Select year</option>
            {YEARS?.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          {errors?.vehicleYear && (
            <p className="text-red-500 text-xs mt-1">{errors?.vehicleYear}</p>
          )}
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onBack}
            className="flex-1 py-3.5 rounded-xl font-bold text-sm border-2 transition-all duration-200 hover:bg-gray-50"
            style={{ borderColor: '#0a1628', color: '#0a1628' }}
          >
            ← Back
          </button>
          <button
            type="submit"
            className="flex-1 py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:opacity-90 active:scale-95 shadow-lg"
            style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
          >
            Continue →
          </button>
        </div>
      </form>
    </div>
  );
};

export default VehicleInfoForm;
